import { useEffect, useState } from 'react';
import axios from 'axios';
import { Coins } from 'lucide-react';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

/**
 * TreasuryDoctrine — Live 3-box revenue split display.
 * Pulls from /api/lineage/status; falls back to defaults if offline.
 * Renders the canonical "Routes X% of the take directly to Mercy" copy.
 */
export default function TreasuryDoctrine({ compact = false, title = 'Treasury Doctrine' }) {
  const [split, setSplit] = useState({ admiral_pct: 50, operations_pct: 40, cyberkids_pct: 10 });

  useEffect(() => {
    axios.get(`${API}/lineage/status`).then(({ data }) => {
      if (data?.current) setSplit(data.current);
    }).catch(() => {});
  }, []);

  return (
    <section data-testid="treasury-doctrine" className={`sov-border bg-gradient-to-br from-[#0A0A0A] via-[#0A0A0A] to-[#D4AF37]/10 ${compact ? 'p-8' : 'p-10 md:p-14'}`}>
      <div className="text-center mb-8">
        <Coins size={26} strokeWidth={1.25} className="text-[#D4AF37] mx-auto mb-4" />
        <div className="text-[10px] tracking-[0.4em] uppercase text-[#D4AF37] mb-3">{title}</div>
        <h3 className="text-2xl md:text-3xl font-extralight max-w-3xl mx-auto leading-[1.25]">
          Every signal fired through LIVE FREE routes{' '}
          <span className="text-[#D4AF37] font-display italic">{split.admiral_pct}%</span> of the take directly to Mercy.
        </h3>
      </div>

      <div data-testid="treasury-cards" className="grid grid-cols-1 md:grid-cols-3 gap-4 max-w-4xl mx-auto">
        <div data-testid="treasury-admiral" className="border-2 border-[#D4AF37] bg-[#D4AF37]/5 p-6 text-center">
          <div className="text-[10px] tracking-[0.3em] uppercase text-[#A3A3A3] mb-2">Admiral · Mercy</div>
          <div className="font-display text-5xl md:text-6xl text-[#D4AF37]">{split.admiral_pct}%</div>
          <div className="text-[10px] tracking-[0.3em] uppercase text-[#666] mt-3">Of every closed signal</div>
        </div>
        <div data-testid="treasury-fleet" className="border border-[#D4AF37]/30 bg-[#0A0A0A] p-6 text-center">
          <div className="text-[10px] tracking-[0.3em] uppercase text-[#A3A3A3] mb-2">Fleet · Operations</div>
          <div className="font-display text-5xl md:text-6xl text-[#F5F5F5]">{split.operations_pct}%</div>
          <div className="text-[10px] tracking-[0.3em] uppercase text-[#666] mt-3">Reserve · runway · payroll</div>
        </div>
        <div data-testid="treasury-anchor" className="border border-[#D4AF37]/30 bg-[#0A0A0A] p-6 text-center">
          <div className="text-[10px] tracking-[0.3em] uppercase text-[#A3A3A3] mb-2">Anchor · Heirs</div>
          <div className="font-display text-5xl md:text-6xl text-[#F5F5F5]">{split.cyberkids_pct}%</div>
          <div className="text-[10px] tracking-[0.3em] uppercase text-[#666] mt-3">Vaulted to lineage</div>
        </div>
      </div>
    </section>
  );
}
